export const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const regexEmailV2 = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/
// export const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,25}$/
export const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])/
export const phoneNumberRegex = /^(?:\+?84|0)(?:\d{9}|(?:3[2-9]|5[689]|7[06-9]|8[1-689]|9\d)\d{7})$/;
export const UrlPattern = /^[a-zA-Z0-9_]*$/;